/** Policy acceptance against the /api/consent endpoints. */

import { get, post } from "@/services/api-client";
import type {
  ConsentStatusResponse,
  PolicyAcceptance,
} from "@patent-studio/api-types";

export function getConsentStatus(): Promise<ConsentStatusResponse> {
  return get<ConsentStatusResponse>("/consent");
}

export function acceptPolicies(
  acceptances: PolicyAcceptance[],
): Promise<ConsentStatusResponse> {
  return post<ConsentStatusResponse>("/consent", { acceptances });
}
